import React from 'react';

export default function IconCalendar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M21.125 4.875H4.875c-.897 0-1.625.728-1.625 1.625v13c0 .898.728 1.625 1.625 1.625h16.25c.898 0 1.625-.727 1.625-1.625v-13c0-.897-.727-1.625-1.625-1.625ZM3.25 10.563h19.5M8.938 6.5V3.25M17.063 6.5V3.25"
      />
    </svg>
  );
}
